import { render, staticRenderFns } from "./tabs-border-card-slider.vue?vue&type=template&id=f157abdc&"
import script from "./tabs-border-card-slider.vue?vue&type=script&lang=js&"
export * from "./tabs-border-card-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports